module.exports = __webpack_public_path__ + "img/dagang-net-escroll-1@2x.0ee07a65.png";